import React from 'react'

import NavigationMenuItemFoldable from "../../menu-items/menu-item-foldable"
import NavigationMenuItemTag from "../../menu-items/tag/menu-item-tag"
import MainMenu_SectionReorderableWithMore from "../../components/menu-controller/menu-section-reordable-with-more"
import ProjectSession from "../../../../core/model2/project/project-session"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../core/gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../core/gd-components/buttons/control-button/@types"
import getOrderedTags from "./actions/get-ordered-tags"
import saveTagsSortPositions from "./actions/save-sort-position"
import openNewTag from "./actions/open-new-tag"

type Props = {
    tags                : ProjectSession[]
    parentProjectId?    : ID
    showAdd             : boolean
    level?              : number
}

// const debug = "NavigationMenuProjectsTagsGroup"
const debug = false

// Tags rendered as a foldable group at the end of the tree.
// Parallel variant of NavigationMenu_ProjectsTags (tags.tsx) which renders them as a menu section.

export default function NavigationMenu_ProjectsTagsGroup(props: Props) {

    const onReorderEnd = (items: any) => {
        debug && console.log(debug, 'onReorderEnd', items)

        saveTagsSortPositions(items, props.tags)
    }

    // add button of the group row - replaces the "New tag" item of the section variant
    const onNewTagClick = (e: React.MouseEvent) => {
        e.stopPropagation()  // do not fold/unfold the group

        debug && console.log(debug, 'onNewTagClick', props.parentProjectId)

        openNewTag(props.parentProjectId)
    }

    // "more" is the right-most control slot (right: 6px), "menu-add" is shifted by 30px to keep
    // room for a more button - this row has none, so the add button takes the right-most slot
    const controls = props.showAdd && (
        <ControlButtonStandard className   = "more"
                               type        = {ControlButtonType.ADD13}
                               size        = {ControlButtonSize.SIZE_24}
                               onClick     = {onNewTagClick}/>
    )

    const components: any[] = _.map(getOrderedTags(props.tags), (item, key)=>({
        item        : item,
        component   : <NavigationMenuItemTag key       = {key}
                                             project   = {item}
                                             level     = {(props.level || 0) + 1}
                                             colorized = {true}/>
    }))

    debug && console.log(debug, 'render', components)

    return (
        <NavigationMenuItemFoldable name        = "Tags"
                                    icon        = "i5-all-tags"
                                    controls    = {controls}>

            <MainMenu_SectionReorderableWithMore countVisibleItems  = {5}
                                                 moreTitle          = "All Tags"
                                                 components         = {components}
                                                 settingsKey        = "project-tags-group"
                                                 showAdd            = {false}
                                                 level              = {(props.level || 0) + 1}
                                                 onReorderEnd       = {onReorderEnd}/>

        </NavigationMenuItemFoldable>
    )
}
